import { customAlphabet } from 'nanoid';

/** returns an id in format `YYMMDDHHMMSS` */
export const generateDateTimeId = () => {
  const now = new Date();

  const parts = [
    // only want last 2 digits
    now.getUTCFullYear() % 100,
    // zero-based
    now.getUTCMonth() + 1,
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds(),
  ].map((n) => `${n}`.padStart(2, '0'));

  return parts.join('');
};

const RANDOM_ID_ALPHABET =
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const RANDOM_ID_LENGTH = 7;

/** returns a 0-9A-Za-z 7 char random string */
export const generateRandomId = customAlphabet(
  RANDOM_ID_ALPHABET,
  RANDOM_ID_LENGTH
);

/** returns an id in format `YYMMDD${nanoid}` where nanoid is 7 random chars */
export const generateDateRandomId = () => {
  const now = new Date();

  const parts = [
    // only want last 2 digits
    now.getUTCFullYear() % 100,
    // zero-based
    now.getUTCMonth() + 1,
    now.getUTCDate(),
  ].map((n) => `${n}`.padStart(2, '0'));

  const randomId = generateRandomId();

  return `${parts.join('')}${randomId}`;
};
